import React, {Component} from 'react'
import {Row, Col, Icon} from 'antd';
import { FaGithub } from 'react-icons/fa';
import { FaStackOverflow } from 'react-icons/fa';
import { FaLinkedinIn } from 'react-icons/fa';
import { FaMailBulk } from 'react-icons/fa';
import { FaSkype } from 'react-icons/fa';

class Home extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <div>
                <div className='ppcard'>
                    <div className='ppcard-inner'>
                        <Row>
                            <Col xs={{span: 24}} lg={{span: 8}}>
                                <img className='ppimage' alt="Tareq Aziz" src={require('./pp.png')}/>
                            </Col>
                            <Col xs={{span: 24}} lg={{span: 16}}>
                                <div className='profile'>
                                    <div className='profile-info'>
                                        <div className="profile-preword">
                                            <span>Hello</span>
                                        </div>
                                        <h1 className="profile-title"><span>I'm</span> Tareq Aziz</h1>
                                        <h2 className="profile-position">Sr. Software Developer</h2>
                                    </div>
                                    <ul className="profile-list">
                                        <li className="clearfix">
                                            <strong className="title">Present Address</strong>
                                            <span className="cont">House#86,​ ​3rd​ ​Floor,​ ​Nagaria​ ​Bari​ ​Road, Dakkhin​ ​Khan,​ ​Chalabon</span>
                                        </li>
                                        <li className="clearfix">
                                            <strong className="title"><span className="button">E-mail</span></strong>
                                            <span className="cont"><a
                                                href="mailto:tareqaziz0065@gmail.com">tareqaziz0065@gmail.com</a></span>
                                        </li>
                                        <li className="clearfix">
                                            <strong className="title">Phone</strong>
                                            <span className="cont"><a href="tel:+8801778266563">+880 1778 266563</a></span>
                                        </li>
                                    </ul>
                                </div>
                            </Col>
                        </Row>
                    </div>

                    <div className="profile-social">
                        <ul className="social">
                            <li>
                                <a className="ripple-centered" href="https://github.com/tareq0065" target="_blank">
                                    <FaGithub
                                        color='#fff'
                                        className='rsicon'
                                    />
                                </a>
                            </li>
                            <li>
                                <a className="ripple-centered" href="https://stackoverflow.com/cv/tareq0065" target="_blank">
                                    <FaStackOverflow
                                        color='#fff'
                                        className='rsicon'
                                    />
                                </a>
                            </li>
                            <li>
                                <a className="ripple-centered" href="https://www.linkedin.com/in/tareqaziz0065" target="_blank">
                                    <FaLinkedinIn
                                        color='#fff'
                                        className='rsicon'
                                    />
                                </a>
                            </li>
                            <li>
                                <a className="ripple-centered" href="skype:live:trick-r?add" target="_blank">
                                    <FaSkype
                                        color='#fff'
                                        className='rsicon'
                                    />
                                </a>
                            </li>
                            <li>
                                <a className="ripple-centered" href="mailto:tareqaziz0065@gmail.com" target="_blank">
                                    <FaMailBulk
                                        color='#fff'
                                        className='rsicon'
                                    />
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <p className='about'>
                    Hello I am Md. Tareq Aziz. Developing is my passion. With 7 years of experience in Software developing.
                    Plays a vital role in developing software on the web platform and website
                    nationally and internationally. Can develop any kind of website and web based software.
                    I have experience to develop cross platform desktop based software for windows and mac.
                    I can develop cross platform apps too.
                </p>

                <h2 className="section-title">Professional Skills</h2>
                <div className='skils'>
                    <Row>
                        <Col xs={{span: 24}} lg={{span: 12}}>
                            <div className="progress-bar animated">
                                <div className="bar-data">
                                    <span className="bar-title">PHP</span>
                                    <span className="bar-value">90%</span>
                                </div>
                                <div className="bar-line">
                                    <span className="bar-fill" data-width="90%" style={{width: '90%'}}></span>
                                </div>
                            </div>
                            <div className="progress-bar animated">
                                <div className="bar-data">
                                    <span className="bar-title">HTML and CSS</span>
                                    <span className="bar-value">90%</span>
                                </div>
                                <div className="bar-line">
                                    <span className="bar-fill" data-width="90%" style={{width: '90%'}}></span>
                                </div>
                            </div>
                            <div className="progress-bar animated">
                                <div className="bar-data">
                                    <span className="bar-title">Wordpress</span>
                                    <span className="bar-value">80%</span>
                                </div>
                                <div className="bar-line">
                                    <span className="bar-fill" data-width="80%" style={{width: '80%'}}></span>
                                </div>
                            </div>
                            <div className="progress-bar animated">
                                <div className="bar-data">
                                    <span className="bar-title">Photoshop</span>
                                    <span className="bar-value">50%</span>
                                </div>
                                <div className="bar-line">
                                    <span className="bar-fill" data-width="50%" style={{width: '50%'}}></span>
                                </div>
                            </div>
                        </Col>
                        <Col xs={{span: 24}} lg={{span: 12}}>
                            <div className="progress-bar animated">
                                <div className="bar-data">
                                    <span className="bar-title">NodeJs</span>
                                    <span className="bar-value">70%</span>
                                </div>
                                <div className="bar-line">
                                    <span className="bar-fill" data-width="70%" style={{width: '70%'}}></span>
                                </div>
                            </div>
                            <div className="progress-bar animated">
                                <div className="bar-data">
                                    <span className="bar-title">ReactJS</span>
                                    <span className="bar-value">80%</span>
                                </div>
                                <div className="bar-line">
                                    <span className="bar-fill" data-width="80%" style={{width: '80%'}}></span>
                                </div>
                            </div>
                            <div className="progress-bar animated">
                                <div className="bar-data">
                                    <span className="bar-title">React Native</span>
                                    <span className="bar-value">80%</span>
                                </div>
                                <div className="bar-line">
                                    <span className="bar-fill" data-width="80%" style={{width: '80%'}}></span>
                                </div>
                            </div>
                            <div className="progress-bar animated">
                                <div className="bar-data">
                                    <span className="bar-title">Illustrator</span>
                                    <span className="bar-value">50%</span>
                                </div>
                                <div className="bar-line">
                                    <span className="bar-fill" data-width="50%" style={{width: '50%'}}></span>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>

            </div>
        )
    }

}

export default Home